import { SellingPlanGroup } from '../../models/selling-plan-group'
import { sellingPlansState } from './index'

export const getSellingPlanGroups = (): SellingPlanGroup[] => {
  return sellingPlansState.sellingPlanGroups.slice(0)
}

export const getSelectedGroupId = (): string => {
  return sellingPlansState.selectedSellingPlanGroupId
}

export const getSelectedSellingPlanId = (): string => {
  return sellingPlansState.selectedSellingPlanId
}

export const getSellingPlanGroup = (id: string): SellingPlanGroup => {
  const group = sellingPlansState.sellingPlanGroups.find(group => group.id === id)
  return {
    ...group
  }
}

export const getSelectedSellingPlanGroupId = (): string => {
  return sellingPlansState.selectedSellingPlanGroupId
}

export const getSelectedSellingPlanGroup = (): SellingPlanGroup => {
  return getSellingPlanGroup(sellingPlansState.selectedSellingPlanGroupId)
}
